<template>
<div>
  <h1>Registration Successful!</h1>
</div>
</template>
<script>
export default {
name: 'RegSuccessPage',
  mounted(){
    this.$API.title="Thank you!";
    setTimeout(()=>{
      this.$router.push("/login");
    },2000)
  }
}
</script>